import { useTranslation } from 'react-i18next';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { LogoutAction } from '@/common/containers/Dashboard/Profile/components/LogoutAction/LogoutAction';
import { ProfileCardSection } from './components/ProfileCardSection/ProfileCardSection';
import { ProfileCompanySection } from './components/ProfileCompanySection/ProfileCompanySection';
import { ProfileHelpSection } from './components/ProfileHelpSection/ProfileHelpSection';
import { ProfilePersonalSection } from './components/ProfilePersonalSection/ProfilePersonalSection';
import { ProfileSettingsSection } from './components/ProfileSettingsSection/ProfileSettingsSection';
import { ProfileSocialSection } from './components/ProfileSocialSection/ProfileSocialSection';

export const ProfileHomePage = () => {
  const { t } = useTranslation();
  return (
    <PageLayout
      headerProps={{
        title: t('dashboard.profile.page.title'),
        actions: <LogoutAction variant="button" />,
      }}
    >
      <ProfileCardSection />
      <ProfilePersonalSection />
      <ProfileCompanySection />
      <ProfileSettingsSection />
      <ProfileHelpSection />
      <ProfileSocialSection />
      <LogoutAction variant="card" />
    </PageLayout>
  );
};
